import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from '../message';
import CabangService from '../../services/cabangServices';
import { clearAuth } from 'store/auth';

export const getList = createAsyncThunk('cabang/list', async (_, thunkAPI) => {
  try {
    const response = await CabangService.getList();

    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getListArchive = createAsyncThunk('cabang/getListArchive', async (_, thunkAPI) => {
  try {
    const response = await CabangService.getListArchive();

    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const createData = createAsyncThunk('cabang/create', async (data, thunkAPI) => {
  try {
    const response = await CabangService.create(data);
    thunkAPI.dispatch(getList());
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const readData = createAsyncThunk('cabang/read', async (id, thunkAPI) => {
  try {
    const response = await CabangService.read(id);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const updateData = createAsyncThunk('cabang/update', async ({ id, data }, thunkAPI) => {
  try {
    const response = await CabangService.update(id, data);
    thunkAPI.dispatch(getList());
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const deleteData = createAsyncThunk('cabang/delete', async (id, thunkAPI) => {
  try {
    const response = await CabangService.del(id);
    thunkAPI.dispatch(getList());
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const changeStatus = createAsyncThunk('cabang/changeStatus', async (data, thunkAPI) => {
  try {
    const response = await CabangService.changeStatus(data.id, data);
    thunkAPI.dispatch(getList());
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getForOperasional = createAsyncThunk('cabang/getForOperasional', async ({ page, perPage, search } = {}, thunkAPI) => {
  try {
    const response = await CabangService.getForOperasional(page, perPage, search);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

const initialState = { isLoading: false, list: [], data: [] };

const cabangSlice = createSlice({
  name: 'cabang',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getList.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(getList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getList.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getListArchive.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getListArchive.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getListArchive.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(createData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(readData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(readData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(readData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(updateData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deleteData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(deleteData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deleteData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeStatus.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(changeStatus.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeStatus.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getForOperasional.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getForOperasional.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getForOperasional.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

const { reducer } = cabangSlice;
export default reducer;
